// import { createSlice } from '@reduxjs/toolkit';

// const filtersSlice = createSlice({
//   name: 'filters',
//   initialState: [],
//   reducers: {
//     addFilter(state, action) {
//       state.push(action.payload);
//     },
//     removeFilter(state, action) {
//       return state.filter((filter) => filter.field !== action.payload.field || filter.value !== action.payload.value);
//     },
//     clearFilters(state) {
//       return [];
//     },
//   },
// });

// export const { addFilter, removeFilter, clearFilters } = filtersSlice.actions;

// export default filtersSlice.reducer;
import { createSlice } from "@reduxjs/toolkit";

const normalizeFilter = (filter) => ({
  ...filter,
  value:
    filter?.value === true
      ? "true"
      : filter?.value === false
        ? "false"
        : String(filter?.value),
});

const filtersSlice = createSlice({
  name: "filters",
  initialState: [],
  reducers: {
    addFilter(state, action) {
      const normalizedFilter = normalizeFilter(action.payload);

      const filterExists = state.some(
        (filter) =>
          filter.field === normalizedFilter.field &&
          String(filter.value) === String(normalizedFilter.value),
      );

      if (!filterExists) {
        state.push(normalizedFilter);
      }
    },

    removeFilter(state, action) {
      const normalizedFilter = normalizeFilter(action.payload);

      return state.filter(
        (filter) =>
          filter.field !== normalizedFilter.field ||
          String(filter.value) !== String(normalizedFilter.value),
      );
    },

    clearFilters() {
      return [];
    },

    setFilters(state, action) {
      if (!Array.isArray(action.payload)) return [];

      return action.payload
        .filter((filter) => filter?.field && filter.value !== undefined)
        .map(normalizeFilter)
        .filter(
          (filter, index, self) =>
            index ===
            self.findIndex(
              (item) =>
                item.field === filter.field &&
                String(item.value) === String(filter.value),
            ),
        );
    },
  },
});

export const { addFilter, removeFilter, clearFilters, setFilters } =
  filtersSlice.actions;

export default filtersSlice.reducer;
